import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MultiShipmentFormGroup } from '../../model';

@Component({
  selector: 'multi-shipment-settings-tab',
  templateUrl: './settings-tab.component.html',
  styleUrls: ['./settings-tab.component.scss'],
  standalone: false,
})
export class SettingsTabComponent {
  @Input({ required: true }) formGroup!: FormGroup<MultiShipmentFormGroup>;
}
